import { Modal } from '@mui/material';
import { ReactComponent as Close } from '../assets/icon/Close.svg';
import PageHeader from './PageHeader';
import { BlueDropDownComponent } from './inputField';
import { usePromptLibraryContext } from '../context/PromptLibraryContext';
import { useEffect, useState } from 'react';
import PlainButton from './ButtonComponents';
import { exportYamlFile } from '../utilities/yamlExport';
import { Copy, CopyIcon } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

export function VersionsPopUp({ handleClose, open }: { handleClose: () => {}; open: boolean }) {
  const { promptDetails } = usePromptLibraryContext();

  const [selectedVersion, setSelectedVersion] = useState(1);
  const [versionsData, setVersionData] = useState([]);

  const [dataToShow, setDataToShow] = useState({
    meta: {},
    prompt: {
      promptName: '',
      is_prompt_type_private: true,
      is_interaction_type_single: true,
      llmTestedWith: '',
      businessGroup: '',
      promptDescription: '',
      systemPrompt: '',
      prompt: [{ text: '' }]
    },
    version_id: '',
    roles: [{ role: '', message: '' }],
    variables: [{ name: '', DefaultValue: '', description: '', VariableName: '', Description: '' }]
  });

  useEffect(() => {
    if (open) {
      setSelectedVersion(parseInt(versionsData?.[0]?.version || 1));
    }
  }, [open, versionsData]);

  useEffect(() => {
    const tempVersions: { version: string; creation_date: string }[] = [];
    promptDetails?.data?.promptsData?.map((item) =>
      tempVersions.push({
        version: item?.prompt?.promptVersion,
        creation_date: item?.prompt?.creation_date
      })
    );
    setVersionData(tempVersions);
  }, [promptDetails]);

  useEffect(() => {
    const temp = promptDetails?.data?.promptsData?.filter(
      (item) => parseInt(item?.prompt?.promptVersion) == selectedVersion
    );

    setTab(0);

    setDataToShow(temp?.[0]);
  }, [selectedVersion, promptDetails]);

  const temp = dataToShow?.prompt;
  const basicData = [
    { fieldName: 'Prompt Name', value: temp?.promptName || 'Dummy' },
    { fieldName: 'Version ID', value: dataToShow?.version_id || 'NA' },
    { fieldName: 'Prompt Type', value: temp?.is_prompt_type_private ? 'Private' : 'Public' },
    {
      fieldName: 'Interactive Type',
      value: temp?.is_interaction_type_single ? 'Single Turn' : 'Multi Turn'
    },
    { fieldName: 'LLM Tested With', value: temp?.llmTestedWith || '-' },
    { fieldName: 'Business Category', value: temp?.businessGroup || '-' },
    { fieldName: 'Prompt Descriptionn', value: temp?.promptDescription }
  ];

  const [tab, setTab] = useState(0);

  const roles = dataToShow?.roles;
  const variables = dataToShow?.variables;
  const prompt = { prompt: temp?.prompt, systemPrompt: temp?.systemPrompt };

  const rolesDisplay = () => {
    return (
      <div>
        {roles?.map((role, index) => (
          <div
            key={'role' + index}
            style={{
              backgroundColor: 'var(--blue_background)',
              margin: '2px 0',
              borderRadius: 10
              // padding: 10
            }}>
            {[
              { fieldName: 'Role', value: role?.role },
              { fieldName: 'Message', value: role?.message }
            ]?.map((item) => (
              <div
                style={{
                  display: 'flex',
                  margin: '0px',
                  backgroundColor: 'rgba(143, 183, 222, 0.1)'
                }}
                key={item?.fieldName}>
                <div
                  style={{
                    width: '20%',
                    maxWidth: '200px',
                    color: 'var(--text-color)'
                  }}
                  className="w600">
                  {item?.fieldName}
                </div>
                <div style={{ color: 'var(--textColor_black)', width: '80%' }}>
                  <ReactMarkdown>{item?.value}</ReactMarkdown>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const promptDisplay = () => {
    const isSingleTurn = dataToShow?.prompt?.is_interaction_type_single;

    return (
      <div className="my-3">
        {[
          { fieldName: 'Prompt', value: temp?.prompt },
          { fieldName: 'System Prompt', value: prompt?.systemPrompt }
        ]?.map(
          (item, index) =>
            ((isSingleTurn && index === 0) || index === 1) && (
              <div
                key={item?.fieldName}
                style={{
                  backgroundColor: 'var(--blue_background)',
                  padding: 10,
                  margin: '5px 0',
                  borderRadius: 10
                }}>
                <p className="my-1 w600" style={{ color: 'var(--text-color)' }}>
                  {item?.fieldName}
                </p>

                {Array.isArray(item?.value) ? (
                  <>
                    {item?.value?.map((prmpt) => (
                      <p style={{ color: 'var(--textColor_black)', margin: 0 }}>{prmpt?.text}</p>
                    ))}
                  </>
                ) : (
                  <p style={{ color: 'var(--textColor_black)' }}>{item?.value}</p>
                )}
              </div>
            )
        )}
      </div>
    );
  };

  const variablesDisplay = () => {
    return (
      <>
        <div>
          {variables?.map((vrbl, index) => (
            <div
              key={'variable' + index}
              style={{
                backgroundColor: 'var(--blue_background)',
                margin: '10px 0',
                borderRadius: 10,
                padding: 10
              }}>
              {[
                {
                  fieldName: 'Variable Name',
                  value: vrbl?.name || vrbl?.VariableName
                },
                { fieldName: 'Default Value', value: vrbl?.DefaultValue },
                { fieldName: 'Description', value: vrbl?.description || vrbl?.Description }
              ]?.map((item) => (
                <div style={{ display: 'flex', margin: '10px 0' }} key={item?.fieldName}>
                  <div style={{ width: '20%', color: 'var(--text-color)' }} className="w600">
                    {item?.fieldName}
                  </div>
                  <div style={{ color: 'var(--textColor_black)', width: '80%' }}>{item?.value}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </>
    );
  };

  const tabOptions = temp?.is_interaction_type_single
    ? ['Prompt', 'Variables']
    : ['Prompt', 'Roles', 'Variables'];

  const functionSelection = temp?.is_interaction_type_single
    ? [promptDisplay(), variablesDisplay()]
    : [promptDisplay(), rolesDisplay(), variablesDisplay()];
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="alignDataCenter">
      <div
        style={{
          backgroundColor: 'rgba(255, 255, 255, 1)',
          border: 'none',
          width: '80vw',
          maxWidth: 1000,
          height: '90vh',
          maxHeight: '700px',
          margin: 'auto',
          borderRadius: '8px',
          padding: 20
        }}>
        <div className="d-flex justify-content-between align-items-start">
          <div className="d-flex  justify-content-between" style={{ width: '35%' }}>
            <PageHeader headerName="Prompt Version Details" description=""></PageHeader>
            <BlueDropDownComponent
              versionsData={versionsData}
              // options={totalVersion || 1}
              selectedVersion={selectedVersion || 1}
              handleSelection={(a, b) => setSelectedVersion(b)}
            />
          </div>

          <div>
            <PlainButton
              styleClass={{ marginRight: 5 }}
              buttonAction={() => {
                exportYamlFile(dataToShow, `${temp?.promptName}_Version_${selectedVersion}.yaml`);
              }}>
              Export as YAML
            </PlainButton>
            <Close style={{ cursor: 'pointer' }} onClick={handleClose} />
          </div>
        </div>

        <div
          style={{
            margin: '20px 0',
            maxHeight: '35%',
            overflow: 'auto',
            scrollbarWidth: 'thin'
          }}>
          <table style={{ width: '100%' }} key={'Table'}>
            <tbody>
              <tr key={'Basic Details'}>
                <td style={{ color: 'var(--description_grey)' }}>Basic Details</td>
              </tr>
              {basicData?.map((dt, index) => (
                <tr style={{ margin: '100px 0', height: 30 }} key={dt?.value + index}>
                  <td style={{ width: 200, color: 'var(--description_2)' }}>
                    {dt?.fieldName}{' '}
                    {index === 1 && (
                      <CopyIcon
                        style={{ width: 20, cursor: 'pointer', color: 'var(--uni_std_clr)' }}
                        onClick={() => navigator.clipboard.writeText(dt?.value || '')}
                      />
                    )}
                  </td>
                  <td>{dt?.value} </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/*  */}

        <div
          style={{
            borderBottom: '1px solid var(--description_grey)',
            display: 'flex',
            height: '30px',
            alignItems: 'center',
            alignContent: 'center'
          }}>
          {tabOptions?.map((item, index) => (
            <div
              key={item + index}
              style={{
                borderBottom: index === tab ? '2px solid var(--description_2)' : '',
                height: '100%',
                margin: 'auto 10px',
                cursor: 'pointer',
                fontWeight: index === tab ? 'bold' : ''
              }}
              onClick={() => setTab(index)}>
              {item}
            </div>
          ))}
        </div>
        <div
          style={{
            maxHeight: '40%',
            overflow: 'auto',
            scrollbarWidth: 'thin'
          }}>
          {functionSelection[tab]}
        </div>
      </div>
    </Modal>
  );
}
